import {
  PublicClientApplication,
  Configuration,
  EventType,
  LogLevel
} from "@azure/msal-browser";

import { getRuntimeConfig } from "./runtimeConfig/runtime-config";

const azureClientId = getRuntimeConfig().MSAL_PUBLIC_CLIENT_ID;
const azureAuthRequestScope = getRuntimeConfig().MSAL_PUBLIC_AUTH_SCOPE;
const azureBackendScope = getRuntimeConfig().MSAL_PUBLIC_BACKEND_SCOPE;

if (!azureClientId || !azureAuthRequestScope) {
  throw new Error("Missing environment variables");
}

const msalConfig: Configuration = {
  auth: {
    clientId: azureClientId,
    authority:
      "https://login.microsoftonline.com/7a7dc48e-9f70-4f4c-941e-bf8aa042f81a",
    redirectUri: "/redirect",
    postLogoutRedirectUri: "/" // Indicates the page to navigate after logout.
  },
  cache: {
    cacheLocation: "localStorage" // This configures where your cache will be stored
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance.initialize();

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload &&
    "account" in event.payload
  ) {
    const account = event.payload.account;
    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }
});

export const loginRequest = {
  scopes: ["openid", "profile"]
};

export const backendRequestScope = {
  scopes: [azureBackendScope]
};

/**
 * Where MSAL's hidden iframe lands during silent token renewal. Passed on the
 * silent request only, so the interactive flow keeps using auth.redirectUri.
 *
 * It has to point at a static page rather than the SPA: /redirect is rewritten
 * to index.html by the static web app, so the whole app would boot inside the
 * iframe, share storage with the tab, and reset the request cache out from
 * under the token exchange the tab is running. See public/blank.html.
 *
 * Registered as a redirect URI on the SPA app registration in both
 * environments. Silent renewal fails outright if it is missing there.
 */
export const silentRedirectUri = "/blank.html";
